import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.FETCH_PURCHASES.REQUEST, saga.fetchPurchases);
    yield takeLatest(constants.FETCH_PURCHASER_ORDER_STATS.REQUEST, saga.fetchPurchaserOrderStats);
    yield takeLatest(constants.CREATE_DISTRIBUTOR_OWNER.REQUEST, saga.createDistributorOrder);
}